import { render, staticRenderFns } from "./AccountOrderDetailsShipmentInfo.vue?vue&type=template&id=047ce648&"
import script from "./AccountOrderDetailsShipmentInfo.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsShipmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports